export const groupBy = function <T>(xs: T[], key: string): { [groupKey: string]: T[] } {
    return xs.reduce(
        function (rv: { [groupKey: string]: T[] }, x: T) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        },
        {}
    );
};
